import { useMemo } from 'react';
import { useSelector } from 'react-redux';
import { selectCurrUser } from '@/store/bootstrap/selectors';
import { useKFlags } from '@/hooks/use-k-flags';

/**
 * Hook to check if requisitions feature is enabled for the current user.
 * Combines the feature flag (feReq) with user-level permission (requisition.enabled).
 *
 * @returns Object containing:
 * - isEnabled: boolean indicating if requisitions are enabled
 * - feReq: feature flag value
 * - requisitionEnabled: user-level permission value
 */
export const useRequisitionsEnabled = () => {
  const currUser = useSelector(selectCurrUser);
  const { feReq } = useKFlags();

  return useMemo(() => {
    const requisitionEnabled = Boolean(currUser?.requisition?.enabled);
    const isEnabled = requisitionEnabled;

    return {
      isEnabled,
      feReq,
      requisitionEnabled,
    };
  }, [feReq, currUser?.requisition?.enabled]);
};
